import { useEffect, useState } from "react";
import {
  Box,
  Switch,
  Typography,
  Button,
  TableBody,
  TableRow,
  TableCell,
  tableCellClasses,
  styled,
  Table,
  TableContainer,
  Paper,
  Dialog,
  DialogContent,
  DialogActions,
  TableHead,
  Card,
  MenuItem,
  Select,
  Checkbox,
  TextField,
  FormControl,
} from "@mui/material";
import { AppDispatch, RootState, useAppSelector } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
// import { OrgData } from "../../../types/company";
import jotformLogo from "../../../assets/images/images-svg/jotform-icon-transparent.svg";
import surveyLogo from "../../../assets/images/images-svg/SurveyIcon.svg";
import internetformLogo from "../../../assets/images/images-png/internet.png";
import resourceCenterLogo from "../../../assets/images/images-svg/resource-center.svg";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ParentAppForm from "./ParentAppForm";
import { BorderColor, Close, ErrorOutline } from "@mui/icons-material";
import {
  DuplicateFormDataById,
  UpdateFormDataById,
  DeleteFormById,
} from "../../../redux/features/intake/intake-form-slice";
// import { IntakeFormList } from "../../../types/businessSettings";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GetFormCards,
  UpdateSessionFormCheckList,
  UpdateFormActiveById,
  UpdateSessionFormApplicable,
  UpdateFormPermissionSettings,
} from "../../../redux/features/forms/form-slice";
import { FormPermissionSetting, IFormCard } from "../../../types/forms";
import LaunchIcon from "@mui/icons-material/Launch";
import moment from "moment";
import { MenuProps } from "../../../constants/providers";
import { NewDataCatalog } from "../../../types/businessSettings";
import { DataCatalogConcepts } from "../../../constants/catalog";
import FileIcon from "../../../assets/images/images-svg/FileIcon.svg";
import ExportIcon from "../../../assets/images/images-svg/ExportFileIcon.svg";
// import FolderIcon from "../../../assets/images/images-svg/FolderIconWhite.svg";
// import { LinkSessionForm } from "../../../redux/features/data-catalog/data-catalog-slice";
import {
  BusinessFormGroup,
  BusinessFormType,
  DefaultSessionFormCategory,
} from "../../../constants/forms";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ClearIcon from "@mui/icons-material/Clear";
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from "@hello-pangea/dnd";
import ShareIcon from "@mui/icons-material/Share";
import {
  getAllAutomation,
  saveAutomationChanges,
  setAllAutomation,
} from "src/redux/features/custom-board/custom-board-slice";
import { ReactComponent as DownloadIcon } from "../../../assets/images/images-svg/Download.svg";
import {
  Model,
  Question,
  QuestionMatrixDropdownModel,
  QuestionMatrixModel,
} from "survey-core";
import { OrgService } from "src/constants/company-user";
import { over } from "node_modules/@types/lodash";
// import { useUser } from "@descope/react-sdk";
// import { getRolesForTenant } from "../../../utils/getRolesForTenant";
// Custom Table
export const StyledTable = styled(Table)(({ theme }) => ({
  [`& .${tableCellClasses.root}`]: {
    borderBottom: "none",
  },
}));

// Custom Table Col style
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
  padding: "5px 20px",
}));

// Custom Table Row style
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#ECF6FF",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    // height: "40px",
  },
  "&:nth-of-type(even)": {
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    // height: "40px",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  // minHeight: "50px",
}));

interface IBussinessForm {
  tabState: string;
}
const BusinessForm: React.FC<IBussinessForm> = ({ tabState }) => {
  //#region variable region
  //Dispatch
  const dispatch: AppDispatch = useDispatch<AppDispatch>();
  const { state } = useLocation();

  // const { user, isUserLoading } = useUser();
  // const currentTenantId = user?.customAttributes?.currentTenantId;
  // const currentRoles = useMemo(() => {
  //   return getRolesForTenant(user, currentTenantId);
  // }, [user, currentTenantId]);

  //track path
  const navigate = useNavigate();

  // Pop up Set for save Files
  const [editDialog, setEditDialog] = useState<boolean>(false);

  //handles the popup for editing Credential details
  const [editFormDetails, setEditFormDetails] = useState<boolean>(false);

  //delete popup handler
  const [deletePopup, setDeletePopup] = useState<boolean>(false);

  //stores selected form type
  const [selectedFormType, setSelectedFormType] =
    useState<string>("Intake Packet Form");

  //filters form group
  const [filterFormGroup, setFilterGroup] = useState<string>(
    state?.group || tabState || "Intake"
  );

  //handles the popup for editing Credential details
  // eslint-disable-next-line
  const [addFormsDetails, setAddFormsDetails] = useState<boolean>(false);

  //open external form
  const [checklistPopup, setChecklistPopup] = useState<boolean>(false);

  const [formChecklists, setFormChecklist] = useState<{
    formId: string;
    checklists: string[];
  }>({
    formId: "",
    checklists: [],
  });
  const [newChecklist, setNewChecklist] = useState<string>("");

  const [permissionModal, setPermissionModal] = useState<boolean>(false);

  const [permissionSettings, setPermissionSettings] =
    useState<FormPermissionSetting>({
      submission: {
        submitterCanSee: false,
      },
    });

  const [formId, setFormId] = useState<string>("");
  const [automationWarning, setAutomationWarning] = useState<boolean>(false);
  const [currentForm, setCurrentForm] = useState<IFormCard>();
  const [formAction, setFormAction] = useState<string>("");

  //stores allForms
  const allForms = useSelector<RootState, IFormCard[]>(
    (state) => state.formSlice.AllForms
  );

  //fetch all catalogData
  const authList = useSelector<RootState, NewDataCatalog[]>((state) =>
    state.dataCatalogSlice.NewDataCatalog.filter(
      (item) => item.catalogName === DataCatalogConcepts.AuthCode
    )
  );

  const insuranceList = useSelector<RootState, NewDataCatalog[]>((state) =>
    state.dataCatalogSlice.NewDataCatalog.filter(
      (item) => item.catalogName === DataCatalogConcepts.Insurance
    )
  );
  const [linkedAuths, setLinkedAuth] = useState<
    {
      formId: string;
      authId: string;
      authValue: string;
    }[]
  >([]);

  const [linkedInsurance, setLinkedInsurance] = useState<
    { formId: string; insuranceId: string; insuranceName: string }[]
  >([]);

  const [formRelatedRules, setFormRelatedRules] = useState<string[]>([]);

  const allAutomation = useAppSelector(
    (state) => state.boardSlice.allAutomation
  );

  //organization service
  const orgService = useAppSelector(
    (state) => state.organizationSlice.orgData.orgService
  );
  //filter business form groups
  const formGroups = Object.values(BusinessFormGroup).filter((item) => {
    if (item === BusinessFormGroup.Assessment) {
      return orgService.includes(OrgService.MentalHealth);
    }
    return true; // keep all other items
  });

  //filter business formTypes
  const formTypes = Object.values(BusinessFormType).filter((item) => {
    if (
      item === BusinessFormType.AssessmentForm ||
      item === BusinessFormType.ShareableAssessmentForm
    ) {
      return orgService.includes(OrgService.MentalHealth);
    }
    return true; // keep all other items
  });
  //#endregion

  //#region method region
  const isAssessmentForm = (formType: string) => {
    return (
      formType === BusinessFormType.AssessmentForm ||
      formType === BusinessFormType.ShareableAssessmentForm
    );
  };

  const updateAutomation = (formId: string) => {
    const effectedAutomation = allAutomation.map((automation) => ({
      ...automation,
      automation: automation.automation.map((rule) =>
        rule.cardAction.form?.includes(formId)
          ? {
              ...rule,
              cardAction: {
                ...rule.cardAction,
                form: [],
              },
              onHold: true,
              apply: false,
            }
          : rule
      ),
    }));
    dispatch(setAllAutomation(effectedAutomation));
    dispatch(saveAutomationChanges());
  };

  const verifyFormRelatedAutomation = (formId: string): boolean => {
    const matchingRules = allAutomation
      .flatMap(({ automation }) => automation) // Flatten automation rules
      .filter(
        (rule) =>
          rule.cardAction.form?.includes(formId) && !rule.onHold && rule.apply
      );

    if (matchingRules.length > 0) {
      // Extract rule names
      const ruleNames = matchingRules.map(
        (rule) => rule.name || "Unnamed Rule"
      );

      // Store rule names in state
      setFormRelatedRules(ruleNames);

      return true; // Form is automated
    }

    return false; // Form is not automated
  };

  // handle active intake forms
  const handleSwitchChange = (item: IFormCard, verified: boolean) => {
    if (!verified) {
      const isAutomated = verifyFormRelatedAutomation(item.id);
      if (isAutomated) {
        setCurrentForm(item);
        setAutomationWarning(true);
        return;
      }
    } else {
      setAutomationWarning(false);
      updateAutomation(item.id);
    }
    dispatch(
      UpdateFormActiveById({
        id: item.id,
        value: !item.active,
      })
    );
  };

  // const handleTypeChange = (e: any) => {
  //   setSchoolAddressObj((prevState: any) => {
  //     return { ...prevState, [e.target.name]: e.target.value };
  //   });
  // };

  //for sorting data
  const sortData = (item: IFormCard[]) => {
    let data: IFormCard[] = [];
    if (item.length > 0) {
      let result = [...item].sort((a: IFormCard, b: IFormCard) => {
        return (new Date(b.updatedAt) as any) - (new Date(a.updatedAt) as any);
      });
      data = [...result];
    }
    return data;
  };

  const getFilteredList = (list: IFormCard[], formGroup: string) => {
    let result: IFormCard[] = [];
    if (list && list.length > 0) {
      if (formGroup === BusinessFormGroup.Intake) {
        result = list.filter(
          (item) =>
            (item.formType === BusinessFormType.IntakeClientForm ||
              item.formType === BusinessFormType.IntakePacketForm) &&
            item.active
        );
      } else if (formGroup === BusinessFormGroup.Onboarding) {
        result = list.filter(
          (item) =>
            (item.formType === BusinessFormType.NewEmployeeForm ||
              item.formType === BusinessFormType.EmployeePacketForm) &&
            item.active
        );
      } else if (formGroup === BusinessFormGroup.Assessment) {
        result = list.filter(
          (item) =>
            isAssessmentForm(item.formType) && item.active && item.active
        );
      } else if (formGroup === BusinessFormGroup.Session) {
        result = list.filter(
          (item) =>
            (item.formType === BusinessFormType.SessionForm ||
              item.formType === BusinessFormType.SessionNoteForm) &&
            item.active
        );
      } else if (formGroup === "Archive") {
        result = list.filter((item) => !item.active);
      } else {
        result = list;
      }
    }
    return result;
  };

  //handles formType change
  const handleFormTypeChange = (item: IFormCard, value: string) => {
    dispatch(
      UpdateFormDataById({
        id: item.id,
        name: item?.name,
        jsonData: item.formSchema,
        formType: value,
      })
    );
  };

  // handle duplication form
  const handleDuplicateForm = (formId: string) => {
    dispatch(DuplicateFormDataById({ id: formId }));
  };

  const handleAuthChange = (value: string[], formId: string) => {
    const authToAdd = value.filter((authValue) => {
      return !linkedAuths.some(
        (item) => authValue === item.authValue && formId === item.formId
      );
    });

    if (authToAdd.length > 0) {
      const auths: { formId: string; authId: string; authValue: string }[] = [];
      authToAdd.forEach((authValue) => {
        const auth = authList.find((item) => item.conceptValue === authValue);
        if (auth) {
          auths.push({ formId, authId: auth.id, authValue: auth.conceptValue });
        }
      });
      setLinkedAuth((prevLinkedAuths) => [...prevLinkedAuths, ...auths]);
    } else {
      const filteredAuth = linkedAuths.filter(
        (item) => !(item.formId === formId && !value.includes(item.authValue))
      );
      setLinkedAuth(filteredAuth);
    }
  };

  const handleInsuranceChange = (value: string[], formId: string) => {
    const insuranceToAdd = value.filter((insurance) => {
      return !linkedInsurance.some(
        (item) => insurance === item.insuranceName && formId === item.formId
      );
    });

    if (insuranceToAdd.length > 0) {
      const insurances: {
        formId: string;
        insuranceId: string;
        insuranceName: string;
      }[] = [];
      insuranceToAdd.forEach((authValue) => {
        const insurance = insuranceList.find(
          (item) => item.conceptValue === authValue
        );
        if (insurance) {
          insurances.push({
            formId,
            insuranceId: insurance.id,
            insuranceName: insurance.conceptValue,
          });
        }
      });
      setLinkedInsurance((prevLinkedAuths) => [
        ...prevLinkedAuths,
        ...insurances,
      ]);
    } else {
      const filteredAuth = linkedInsurance.filter(
        (item) =>
          !(item.formId === formId && !value.includes(item.insuranceName))
      );
      setLinkedInsurance(filteredAuth);
    }
  };
  const hasDifference = (
    selectedIds: string[],
    existingIds: string[]
  ): boolean => {
    if (!selectedIds.length && !existingIds?.length) {
      return false;
    }
    if (selectedIds.length !== existingIds?.length) {
      // Check if lengths are different
      return true;
    }
    for (const id of selectedIds) {
      if (!existingIds.includes(id)) {
        return true;
      }
    }
    for (const id of existingIds) {
      if (!selectedIds.includes(id)) {
        return true;
      }
    }
    return false; // No difference found
  };
  const handleApplicable = (form: IFormCard, linkType: string) => {
    let selectedAuthIds: string[] = linkedAuths.reduce<string[]>(
      (acc, item) => {
        if (item.formId === form.id) acc.push(item.authId);
        return acc;
      },
      []
    );
    let selectedInsuranceIds: string[] = linkedInsurance.reduce<string[]>(
      (acc, item) => {
        if (item.formId === form.id) acc.push(item.insuranceId);
        return acc;
      },
      []
    );
    if (linkType === "authIds") {
      const isDifferent = hasDifference(
        selectedAuthIds,
        form.applicableTo?.authCodes
      );
      if (!isDifferent) {
        return;
      }
    }

    if (linkType === "insuranceIds") {
      const isDifferent = hasDifference(
        selectedInsuranceIds,
        form.applicableTo?.insurances
      );
      if (!isDifferent) {
        return;
      }
    }

    dispatch(
      UpdateSessionFormApplicable({
        formId: form.id,
        insurances: selectedInsuranceIds,
        authCodes: selectedAuthIds,
      })
    );
  };

  const dragHandler = ({ source, destination }: DropResult) => {
    if (
      !destination ||
      destination.index === undefined ||
      source.index === destination.index
    ) {
      return;
    }
    const updatedChecklist = Array.from(formChecklists.checklists);
    const [draggedItem] = updatedChecklist.splice(source.index, 1);
    updatedChecklist.splice(destination.index, 0, draggedItem);
    setFormChecklist({ ...formChecklists, checklists: updatedChecklist });
  };
  const handleUpdatePermission = () => {
    dispatch(
      UpdateFormPermissionSettings({
        formId: formId,
        permissionSetting: permissionSettings,
      })
    );
    setPermissionModal(false);
    // setPermissionSettings({
    //   submission: {
    //     submitterCanSee: false,
    //   },
    // });
  };

  // Function to trigger download of the blank form

  const safeGet = (obj: any, prop: string, defaultValue: any = undefined) => {
    return obj && typeof obj === "object" && prop in obj
      ? obj[prop]
      : defaultValue;
  };

  // Replace with your UI component library
  const generatePrintableForm = (survey: Model): string => {
    // Create a new HTML document for printing
    let printContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>${survey.title || "Survey Form"}</title>
      <style>
        body { 
          font-family: Arial, sans-serif; 
          line-height: 1.6; 
          padding: 20px;
        }
        .survey-title { 
          font-size: 24px; 
          font-weight: bold; 
          margin-bottom: 10px; 
          text-align: center;
        }
        .survey-description { 
          font-style: italic; 
          margin-bottom: 20px; 
          text-align: center;
        }
        .page { margin-bottom: 30px; }
        .page-title { 
          font-size: 18px; 
          margin-bottom: 15px; 
          border-bottom: 1px solid #ccc;
          padding-bottom: 5px;
        }
        .question { 
          margin-bottom: 20px; 
          padding: 10px;
          border: 1px solid #eee;
        }
        .question-title { 
          font-weight: bold; 
          margin-bottom: 5px; 
        }
        .question-description { 
          font-style: italic; 
          margin-bottom: 10px; 
          color: #666;
        }
        .answer-space { 
          border: 1px solid #ccc; 
          min-height: 30px; 
          margin-top: 5px;
          width: 100%;
        }
        .rating-box {
          display: flex;
          gap: 10px;
          justify-content: start;
          margin: 20px 10px;
        }
        .rating-item {
          border: 1px solid #000;
          padding: 10px 15px;
          text-align: center;
          cursor: pointer;
        }
        .checkbox-item, .radio-item {
          display: flex;
          align-items: center;
          margin: 5px 0;
        }
        .checkbox-box, .radio-circle {
          border: 1px solid #000;
          margin-right: 10px;
          display: inline-block;
        }
        .checkbox-box {
          width: 15px;
          height: 15px;
        }
        .radio-circle {
          width: 15px;
          height: 15px;
          border-radius: 50%;
        }
        .text-input {
          border-bottom: 1px solid #000;
          min-height: 25px;
          width: 100%;
          margin-top: 5px;
        }
        .comment-input {
          border: 1px solid #000;
          min-height: 100px;
          width: 100%;
          margin-top: 5px;
        }
        .file-input {
          width: 200px;
          height: 200px;
          border: 1px solid #000;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 20px 10px;
        }
        .options-list {
          font-size: 12px;
          color: #666;
          margin-top: 5px;
        }
        .required-mark {
          color: red;
          margin-left: 3px;
        }
        @media print {
          .page-break { page-break-after: always; }
          body { padding: 0; }
        }
      </style>
    </head>
    <body>
      <div class="survey-title">${survey.title || "Survey Form"}</div>
      ${
        survey.description
          ? `<div class="survey-description">${survey.description}</div>`
          : ""
      }
      <div class="survey-form">
  `;

    // Process each page and question
    survey.pages.forEach((page, pageIndex) => {
      if (pageIndex > 0) {
        printContent += '<div class="page-break"></div>';
      }

      printContent += `<div class="page">`;
      if (survey.pages.length > 1) {
        printContent += `<div class="page-title">Page ${pageIndex + 1}${
          page.title ? ": " + page.title : ""
        }</div>`;
      }

      page.elements.forEach((element) => {
        // Cast element to Question type for proper type checking
        const question = element as Question;

        printContent += `<div class="question">`;
        printContent += `<div class="question-title">
        ${safeGet(question, "title", question.name)}
        ${question.isRequired ? '<span class="required-mark">*</span>' : ""}
      </div>`;

        if (safeGet(question, "description")) {
          printContent += `<div class="question-description">${question.description}</div>`;
        }

        // Generate different input types based on question type
        const questionType = question.getType();

        switch (questionType) {
          case "text":
            printContent += `<div class="text-input"></div>`;
            break;

          case "comment":
            printContent += `<div class="comment-input"></div>`;
            break;

          case "checkbox":
            const checkboxChoices = safeGet(question, "choices", []);
            checkboxChoices.forEach((choice: any) => {
              const choiceText =
                typeof choice === "object"
                  ? choice.text || choice.value
                  : choice;
              printContent += `
              <div class="checkbox-item">
                <div class="checkbox-box"></div>
                <span>${choiceText}</span>
              </div>`;
            });

            // Add "Other" option if enabled
            if (safeGet(question, "hasOther", false)) {
              printContent += `
              <div class="checkbox-item">
                <div class="checkbox-box"></div>
                <span>Other (please specify): </span>
              </div>
              <div class="text-input" style="width: 70%; margin-left: 25px;"></div>`;
            }
            break;

          case "radiogroup":
            const radioChoices = safeGet(question, "choices", []);
            radioChoices.forEach((choice: any) => {
              const choiceText =
                typeof choice === "object"
                  ? choice.text || choice.value
                  : choice;
              printContent += `
              <div class="checkbox-item">
                <div class="checkbox-box"></div>
                <span>${choiceText}</span>
              </div>`;
            });

            // Add "Other" option if enabled
            if (safeGet(question, "hasOther", false)) {
              printContent += `
              <div class="checkbox-item">
                <div class="checkbox-box"></div>
                <span>Other (please specify): </span>
              </div>
              <div class="text-input" style="width: 70%; margin-left: 25px;"></div>`;
            }
            break;

          case "dropdown":
            const dropdownChoices = safeGet(question, "choices", []);
            dropdownChoices.forEach((choice: any) => {
              const choiceText =
                typeof choice === "object"
                  ? choice.text || choice.value
                  : choice;
              printContent += `
              <div class="checkbox-item">
                <div class="checkbox-box"></div>
                <span>${choiceText}</span>
              </div>`;
            });

            // Add "Other" option if enabled
            if (safeGet(question, "hasOther", false)) {
              printContent += `
              <div class="checkbox-item">
                <div class="checkbox-box"></div>
                <span>Other (please specify): </span>
              </div>
              <div class="text-input" style="width: 70%; margin-left: 25px;"></div>`;
            }
            break;

          case "boolean":
            printContent += `
                  <div class="checkbox-item">
                  <div class="checkbox-box"></div>
                  <span>Yes</span>
                </div>
                <div class="checkbox-item">
                  <div class="checkbox-box"></div>
                  <span>No</span>
                </div>`;
            break;

          case "rating":
            printContent += `<div class="rating-container">`;
            const rateMin = safeGet(question, "rateMin", 1);
            const rateMax = safeGet(question, "rateMax", 5);
            printContent += `<div class="rating-box">`;
            for (let i = rateMin; i <= rateMax; i++) {
              printContent += `<div class="rating-item">${i}</div>`;
            }
            printContent += `</div>`;
            break;

          case "file":
            printContent += `<div class="file-input">
            Attach file</div>`;

            break;
          case "matrix":
            // Type assertion for matrix question
            const matrixQuestion = question as QuestionMatrixModel;

            // Create a table for matrix questions
            printContent += `<table style="width: 100%; border-collapse: collapse; margin-top: 10px;">`;

            // Header row with column labels
            printContent += `<tr><th></th>`;
            const columns = matrixQuestion.columns || [];
            columns.forEach((column: any) => {
              const columnText =
                typeof column === "object"
                  ? column.text || column.value
                  : column;
              printContent += `<th style="padding: 5px; text-align: center;">${columnText}</th>`;
            });
            printContent += `</tr>`;

            // Rows
            const rows = matrixQuestion.rows || [];
            rows.forEach((row: any) => {
              const rowText =
                typeof row === "object" ? row.text || row.value : row;
              printContent += `<tr><td style="padding: 5px;">${rowText}</td>`;

              columns.forEach(() => {
                printContent += `<td style="padding: 5px; text-align: center;">
                <div class="radio-circle" style="margin: 0 auto;"></div>
              </td>`;
              });

              printContent += `</tr>`;
            });

            printContent += `</table>`;
            break;

          case "matrixdropdown":
            // Type assertion for matrix dropdown question
            const matrixDropdownQuestion =
              question as QuestionMatrixDropdownModel;

            // Create a table for matrix dropdown questions
            printContent += `<table style="width: 100%; border-collapse: collapse; margin-top: 10px;">`;

            // Header row with column labels
            printContent += `<tr><th></th>`;
            const matrixColumns = matrixDropdownQuestion.columns || [];
            matrixColumns.forEach((column: any) => {
              const columnText =
                typeof column === "object"
                  ? column.text || column.value
                  : column;
              printContent += `<th style="padding: 5px; text-align: center;">${columnText}</th>`;
            });
            printContent += `</tr>`;

            // Rows
            const matrixRows = matrixDropdownQuestion.rows || [];
            matrixRows.forEach((row: any) => {
              const rowText =
                typeof row === "object" ? row.text || row.value : row;
              printContent += `<tr><td style="padding: 5px;">${rowText}</td>`;

              matrixColumns.forEach(() => {
                printContent += `<td style="padding: 5px; text-align: center;">
                <div class="text-input" style="min-height: 20px;"></div>
              </td>`;
              });

              printContent += `</tr>`;
            });

            printContent += `</table>`;
            break;

          default:
            printContent += `<div class="answer-space"></div>`;
        }

        printContent += `</div>`;
      });

      printContent += `</div>`;
    });

    printContent += `
      </div>
    </body>
    </html>
  `;

    return printContent;
  };

  // Function to trigger download of the blank form
  const downloadBlankForm = (survey: IFormCard["formSchema"]) => {
    const surveyJson = new Model(survey);
    const printableContent = generatePrintableForm(surveyJson);

    // Create a Blob with the HTML content
    const blob = new Blob([printableContent], { type: "text/html" });

    // Create a download link and trigger the download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${
      typeof survey?.title !== "string"
        ? survey.title?.default
        : survey.title || "Survey"
    }_blank_form.html`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  //#endregion

  //#region useEffect region
  useEffect(() => {
    dispatch(GetFormCards({}));
    dispatch(getAllAutomation());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const sessionForms = allForms.filter(
      (item) =>
        item.formType === BusinessFormType.SessionForm ||
        item.formType === BusinessFormType.SessionNoteForm
    );

    //create linkedAuth based on sessionForm.applicableTo.authCodes
    const linkedAuths: {
      formId: string;
      authId: string;
      authValue: string;
    }[] = [];
    const linkedInsurances: {
      formId: string;
      insuranceId: string;
      insuranceName: string;
    }[] = [];

    sessionForms.forEach((form) => {
      form.applicableTo?.authCodes?.forEach((authCode) => {
        //lookup authCode from authList
        const auth = authList.find((item) => item.id === authCode);
        if (auth) {
          linkedAuths.push({
            formId: form.id,
            authId: auth.id,
            authValue: auth?.conceptValue || "",
          });
        }
      });

      form.applicableTo?.insurances?.forEach((insurance) => {
        const insuranceData = insuranceList.find(
          (item) => item.id === insurance
        );
        if (insuranceData) {
          linkedInsurances.push({
            formId: form.id,
            insuranceId: insuranceData.id,
            insuranceName: insuranceData?.conceptValue || "",
          });
        }
      });
    });

    setLinkedAuth(linkedAuths);
    setLinkedInsurance(linkedInsurances);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allForms.length, authList.length, insuranceList.length]);
  //#endregion

  return (
    <Box>
      <Box mt="22px">
        <div style={{ marginBottom: 0 }}>
          <div className="forms-header">
            <Box
              sx={{
                display: { xs: "block", md: "flex" },
                gap: "15px",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <Typography
                className="listingTable__title"
                gutterBottom
                // variant="h6"
                style={{ fontWeight: 500, fontSize: "20px" }}
              >
                Select Group:
              </Typography>
              <Box sx={{ display: "flex", gap: "15px" }} className="form-tabs">
                {formGroups?.map((item, index) => (
                  <Box className="fromGroup-chips" key={item}>
                    <Card
                      key={index}
                      className={
                        filterFormGroup === item ? "fromGroup-chip-active" : ""
                      }
                      onClick={() => {
                        filterFormGroup === item
                          ? setFilterGroup("")
                          : setFilterGroup(item);
                      }}
                    >
                      {item}
                    </Card>
                  </Box>
                ))}
                <Box className="fromGroup-chips">
                  <Card
                    className={
                      filterFormGroup === "Archive"
                        ? "fromGroup-chip-active"
                        : ""
                    }
                    onClick={() => {
                      filterFormGroup === "Archive"
                        ? setFilterGroup("")
                        : setFilterGroup("Archive");
                    }}
                  >
                    Archive
                  </Card>
                </Box>
              </Box>
            </Box>

            <div className="formAction-buttons">
              {filterFormGroup !== BusinessFormGroup.Assessment &&
                filterFormGroup !== "Archive" && (
                  <>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        if (filterFormGroup === "Intake") {
                          navigate("/surveycreator/newintakeform", {
                            state: {
                              type: BusinessFormType.IntakePacketForm,
                            },
                          });
                        } else if (filterFormGroup === "Onboarding") {
                          navigate("/surveycreator/newemployeeform", {
                            state: {
                              type: BusinessFormType.EmployeePacketForm,
                            },
                          });
                        } else if (filterFormGroup === "Session") {
                          navigate("/surveycreator/newSessionForm", {
                            state: {
                              type: "Session Form",
                            },
                          });
                        }
                      }}
                    >
                      <img src={FileIcon} alt="" /> Design Form
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setEditDialog(true);
                        setAddFormsDetails(true);
                      }}
                    >
                      <img src={ExportIcon} alt="" />
                      Link External Form
                    </Button>
                  </>
                )}

              <Button
                variant="outlined"
                onClick={() => {
                  navigate("/resourcehub", {
                    state: {
                      tab: "Forms",
                      group: filterFormGroup,
                    },
                  });
                }}
              >
                <img
                  className="survetFormLogo"
                  src={resourceCenterLogo}
                  alt="resourceCenterLogo"
                />
                Resource Center
              </Button>
            </div>
          </div>

          <Box className="listingTable">
            <TableContainer component={Paper} className="tableResponsive">
              <StyledTable
                sx={{
                  minWidth: 820,
                  borderCollapse: "separate",
                  cursor: "pointer",
                }}
                aria-label="customized table"
              >
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">Form Name</StyledTableCell>
                    <StyledTableCell align="center">Form Type</StyledTableCell>
                    {filterFormGroup === BusinessFormGroup.Session && (
                      <>
                        <StyledTableCell align="center">
                          Insurance
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Auth Code
                        </StyledTableCell>
                        <StyledTableCell>Checklist</StyledTableCell>
                      </>
                    )}
                    <StyledTableCell align="center">Updated On</StyledTableCell>
                    <StyledTableCell align="center">Action</StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {allForms?.length > 0 &&
                    (filterFormGroup
                      ? sortData(getFilteredList(allForms, filterFormGroup))
                      : sortData(allForms)
                    )?.map((item) => {
                      const authValues = linkedAuths
                        .filter((authCode) => authCode.formId === item.id)
                        ?.map((auth) => auth.authValue);
                      const insuranceValues = linkedInsurance
                        .filter((insurance) => insurance.formId === item.id)
                        ?.map((insurance) => insurance.insuranceName);
                      return (
                        <StyledTableRow
                          style={{ borderRadius: 20 }}
                          key={item.id}
                        >
                          {/* column - form logo & name */}
                          <StyledTableCell>
                            <Box display={"flex"} gap={2} alignItems={"center"}>
                              <span>
                                {item.resource && item.resource?.id !== "" ? (
                                  <img
                                    className="formLogo"
                                    src={resourceCenterLogo}
                                    alt="resourceCenterLogo"
                                  />
                                ) : item.isJot === true ? (
                                  <img
                                    className="jotformLogo"
                                    src={jotformLogo}
                                    alt="jotformLogo "
                                  />
                                ) : item.formSchema !== null ? (
                                  <img
                                    className="survetFormLogo"
                                    src={surveyLogo}
                                    alt="surveyLogo"
                                  />
                                ) : (
                                  <img
                                    className="formLogo"
                                    src={internetformLogo}
                                    alt="internetformLogo "
                                  />
                                )}
                              </span>
                              <Typography>{item.name}</Typography>
                              {item.url !== null && (
                                <a
                                  href={item.url}
                                  target="_blank"
                                  rel="noreferrer"
                                  style={{ color: "black" }}
                                >
                                  <LaunchIcon />
                                </a>
                              )}
                            </Box>
                          </StyledTableCell>

                          {/* column - form type */}
                          <StyledTableCell>
                            <Box>
                              {/* {item.formType ===
                                  BusinessFormType.IntakePacketForm ||
                                item.formType ===
                                  BusinessFormType.EmployeePacketForm ||
                                item.formType ===
                                  BusinessFormType.SessionForm ? ( */}
                              <Select
                                className="form-control"
                                labelId="demo-simple-select-label"
                                value={item.formType}
                                name="formType"
                                onChange={(e) =>
                                  handleFormTypeChange(item, e.target.value)
                                }
                                MenuProps={MenuProps}
                                style={{
                                  maxWidth: "200px",
                                  width: "200px",
                                  height: "33px",
                                }}
                              >
                                {formTypes.map((formType) => (
                                  <MenuItem key={formType} value={formType}>
                                    {formType}
                                  </MenuItem>
                                ))}
                              </Select>
                              {/* ) : (
                                  <Box className="border-boxBlockForm">
                                    {item.formType}
                                  </Box>
                                )} */}
                            </Box>
                          </StyledTableCell>

                          {/* column - SessionForm Only: insurance, authCode, checklist */}
                          {(item.formType === BusinessFormType.SessionForm ||
                            item.formType ===
                              BusinessFormType.SessionNoteForm) && (
                            <>
                              <StyledTableCell>
                                <Select
                                  // className="form-control"
                                  labelId="demo-simple-select-label"
                                  multiple
                                  value={insuranceValues}
                                  name="Insurance"
                                  onChange={(e) => {
                                    handleInsuranceChange(
                                      e.target.value as string[],
                                      item.id
                                    );
                                  }}
                                  onClose={() => {
                                    handleApplicable(item, "insuranceIds");
                                  }}
                                  renderValue={(selected: string[]) =>
                                    selected.join(", ")
                                  }
                                  MenuProps={MenuProps}
                                  style={{
                                    width: "250px",
                                    height: "33px",
                                  }}
                                >
                                  {insuranceList?.map((insurance) => (
                                    <MenuItem value={insurance.conceptValue}>
                                      <Checkbox
                                        checked={insuranceValues.includes(
                                          insurance.conceptValue
                                        )}
                                      />
                                      {insurance.conceptValue}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </StyledTableCell>
                              <StyledTableCell>
                                <Select
                                  // className="form-control"
                                  labelId="demo-simple-select-label"
                                  multiple
                                  value={authValues}
                                  name="Auth Code"
                                  onChange={(e) => {
                                    handleAuthChange(
                                      e.target.value as string[],
                                      item.id
                                    );
                                  }}
                                  onClose={() => {
                                    handleApplicable(item, "authIds");
                                  }}
                                  renderValue={(selected: string[]) =>
                                    selected.join(", ")
                                  }
                                  MenuProps={MenuProps}
                                  style={{
                                    width: "150px",
                                    height: "33px",
                                  }}
                                >
                                  {authList?.map((auth) => (
                                    <MenuItem value={auth.conceptValue}>
                                      <Checkbox
                                        checked={authValues.includes(
                                          auth.conceptValue
                                        )}
                                      />
                                      {auth.conceptValue}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </StyledTableCell>
                              <StyledTableCell>
                                <Button
                                  onClick={() => {
                                    setFormChecklist({
                                      formId: item.id,
                                      checklists: item.checkList,
                                    });
                                    setChecklistPopup(true);
                                  }}
                                >
                                  {item.checkList.length} items{" "}
                                  <ChecklistIcon color="primary" />
                                </Button>
                              </StyledTableCell>
                            </>
                          )}
                          <StyledTableCell>
                            {item.updatedAt &&
                              `${moment(item.updatedAt as any).format("lll")}`}
                          </StyledTableCell>

                          {/* column - action */}
                          <StyledTableCell
                            style={{ display: "flex", gap: "23px" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                marginTop: "10px",
                                alignItems: "center",
                                gap: "20px",
                              }}
                            >
                              {/* for toggle button */}
                              {
                                // item.formType !==
                                // BusinessFormType.IntakeClientForm &&
                                // item.formType !==
                                //   BusinessFormType.NewEmployeeForm && (
                                <Switch
                                  checked={item.active}
                                  onChange={() => {
                                    setFormAction("Update");
                                    handleSwitchChange(item, false);
                                  }}
                                />
                                // )
                              }

                              {/* for delete button */}
                              {/* {(!isAssessmentForm(item.formType) || 
                              (isAssessmentForm(item.formType) && 
                              (currentRoles.includes("Owner") ||
                              currentRoles.includes("ABAEngine Admin"))
                            )) && ( */}
                              {!isAssessmentForm(item.formType) && (
                                <>
                                  <BorderColor
                                    color="primary"
                                    onClick={() => {
                                      if (item.formSchema !== null) {
                                        navigate("/surveycreator/" + item.id, {
                                          state: {
                                            url: item.url,
                                            type: item.formType,
                                          },
                                        });
                                      } else {
                                        setEditDialog(true);
                                        setEditFormDetails(true);
                                        setCurrentForm(item);
                                      }
                                    }}
                                  />
                                  {
                                    // item.formType !==
                                    // BusinessFormType.IntakeClientForm &&
                                    // item.formType !==
                                    //   BusinessFormType.NewEmployeeForm &&
                                    // Object.values(
                                    //   DefaultSessionFormCategory
                                    // ).includes(
                                    //   item.formCategory as DefaultSessionFormCategory
                                    // ) && (
                                    <DeleteIcon
                                      color="primary"
                                      onClick={() => {
                                        const isAutomated =
                                          verifyFormRelatedAutomation(item.id);
                                        setCurrentForm(item);
                                        if (isAutomated) {
                                          setAutomationWarning(true);
                                          setFormAction("Delete");
                                          return;
                                        }
                                        setDeletePopup(true);
                                      }}
                                    />
                                    // )
                                  }

                                  <ContentCopyIcon
                                    color="primary"
                                    onClick={() => handleDuplicateForm(item.id)}
                                  ></ContentCopyIcon>
                                </>
                              )}
                              <ShareIcon
                                color="primary"
                                onClick={() => {
                                  // if (item.permissionSetting) {
                                  setPermissionSettings(item.permissionSetting);
                                  // }
                                  setFormId(item.id);
                                  setPermissionModal(true);
                                }}
                              />
                              <DownloadIcon
                                onClick={() =>
                                  downloadBlankForm(item.formSchema)
                                }
                              />
                            </Box>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
              </StyledTable>
            </TableContainer>
          </Box>
        </div>
        {editDialog && (
          <Dialog open={editDialog} className="largeModel">
            <Box>
              <Box className="largeModel__head">
                <Typography variant="h5" className="largeModel__title">
                  Add Form / Edit Form
                </Typography>
                <Button
                  className="largeModel__closeBtn"
                  onClick={() => {
                    setEditDialog(false);
                    if (editFormDetails) {
                      setEditFormDetails(false);
                    } else {
                      setAddFormsDetails(false);
                    }
                  }}
                >
                  <Close />
                </Button>
              </Box>
            </Box>

            <ParentAppForm
              editFormDetails={editFormDetails}
              setAddFormsDetails={setAddFormsDetails}
              setEditFormDetails={setEditFormDetails}
              parentformId={currentForm?.id || ""}
              setEditDialog={setEditDialog}
              setSelectedFormType={setSelectedFormType}
              selectedFormType={selectedFormType}
              formType={selectedFormType}
            />
          </Dialog>
        )}

        <Dialog open={deletePopup} className="smallModel">
          <div>
            <DialogContent>Do you want to delete this form?</DialogContent>
            <DialogActions>
              <Button
                className="border-button"
                variant="contained"
                onClick={() => setDeletePopup(false)}
                color="secondary"
              >
                No
              </Button>
              <Button
                className="button"
                variant="contained"
                onClick={() => {
                  if (currentForm) {
                    dispatch(
                      DeleteFormById({
                        id: currentForm.id,
                        formType: "Intake Packet Form",
                      })
                    );
                    if (formAction === "Delete") {
                      updateAutomation(currentForm.id);
                      setFormAction("");
                    }
                  }
                  setDeletePopup(false);
                }}
              >
                Yes
              </Button>
            </DialogActions>
          </div>
        </Dialog>
        <Dialog open={checklistPopup} className="checklistModal" style={{ overflow: "hidden" }} >
          <Box className="smallModel__head" style={{ padding: "12px 16px" }}>
            <Typography variant="h3" className="smallModel__title">
              Checklist
            </Typography>
            <Button
              className="smallModel__closeBtn"
              onClick={() => {
                setChecklistPopup(false);
              }}
            >
              <Close />
            </Button>
          </Box>
          <DragDropContext onDragEnd={dragHandler} >
            <DialogContent>
              <Box className="add-checklist">
                <Box className="fromGroup checklist-bar">
                  <FormControl>
                    <TextField
                      className="border-none"
                      placeholder="Add checklist"
                      value={newChecklist}
                      onChange={(e) => setNewChecklist(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && newChecklist !== "") {
                          setFormChecklist({
                            ...formChecklists,
                            checklists: [
                              ...formChecklists.checklists,
                              newChecklist,
                            ],
                          });
                          setNewChecklist("");
                        }
                      }}
                    />
                  </FormControl>
                  <button
                    onClick={() => {
                      if (newChecklist === "") {
                        return;
                      }
                      setFormChecklist({
                        ...formChecklists,
                        checklists: [
                          ...formChecklists.checklists,
                          newChecklist,
                        ],
                      });
                      setNewChecklist("");
                    }}
                  >
                    Add
                  </button>
                </Box>
              </Box>

              <Droppable droppableId="droppableId" direction="vertical">
                {(provider) => (
                  <Box
                    className="checklists"
                    ref={provider.innerRef}
                    {...provider.droppableProps}
                  >
                    {formChecklists.formId !== "" &&
                      formChecklists.checklists?.map((item, index) => (
                        <Draggable
                          key={item + index}
                          draggableId={item}
                          index={index}
                        >
                          {(provider) => (
                            <Box
                              ref={provider.innerRef}
                              {...provider.draggableProps}
                              {...provider.dragHandleProps}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                background: "#d8ecff",
                                borderRadius: "5px",
                                padding: "5px",
                                margin: "0px 5px",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography variant="caption">{item}</Typography>
                              <ClearIcon
                                fontSize="small"
                                onClick={() => {
                                  const updatedChecklist =
                                    formChecklists.checklists.filter(
                                      (ele) => ele !== item
                                    );
                                  setFormChecklist({
                                    ...formChecklists,
                                    checklists: updatedChecklist,
                                  });
                                }}
                                sx={{ marginLeft: "5px", cursor: "pointer" }}
                              />
                            </Box>
                          )}
                        </Draggable>
                      ))}
                    {provider.placeholder}
                  </Box>
                )}
              </Droppable>
            </DialogContent>
          </DragDropContext>
          <DialogActions>
            <Button
              className="button"
              variant="contained"
              onClick={() => {
                setChecklistPopup(false);
                if (formChecklists.formId !== "") {
                  dispatch(
                    UpdateSessionFormCheckList({
                      checkList: formChecklists.checklists,
                      formId: formChecklists.formId,
                    })
                  );
                }
              }}
            >
              Save Changes
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={permissionModal} className="checklistModal">
          <Box className="smallModel__head" style={{ padding: "12px 16px" }}>
            <Typography variant="h3" className="smallModel__title">
              Visibility Permission
            </Typography>
            <Button
              className="smallModel__closeBtn"
              onClick={() => {
                setPermissionModal(false);
                setPermissionSettings({
                  submission: {
                    submitterCanSee: false,
                  },
                });
              }}
            >
              <Close />
            </Button>
          </Box>
          <DialogContent>
            <Box className="permission-setting">
              <Typography className="permission-setting-label">
                Share Form Files with the submitter.
              </Typography>
              <Switch
                checked={
                  permissionSettings?.submission.submitterCanSee || false
                }
                onChange={() => {
                  setPermissionSettings({
                    submission: {
                      submitterCanSee:
                        !permissionSettings.submission.submitterCanSee,
                    },
                  });
                }}
              />
            </Box>
          </DialogContent>
          <DialogActions className="checklistModal-footer">
            <Button
              className="button"
              variant="contained"
              onClick={handleUpdatePermission}
            >
              Save Changes
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={permissionModal} className="checklistModal">
          <Box className="smallModel__head" style={{ padding: "12px 16px" }}>
            <Typography variant="h3" className="smallModel__title">
              Visibility Permission
            </Typography>
            <Button
              className="smallModel__closeBtn"
              onClick={() => {
                setPermissionModal(false);
                // setPermissionSettings({
                //   submission: {
                //     submitterCanSee: false,
                //   },
                // });
              }}
            >
              <Close />
            </Button>
          </Box>
          <DialogContent>
            <Box className="permission-setting">
              <Typography className="permission-setting-label">
                Share Form Files with the submitter.
              </Typography>
              <Switch
                checked={
                  permissionSettings?.submission.submitterCanSee || false
                }
                onChange={() => {
                  setPermissionSettings({
                    submission: {
                      submitterCanSee:
                        !permissionSettings.submission.submitterCanSee,
                    },
                  });
                }}
              />
            </Box>
          </DialogContent>
          <DialogActions className="checklistModal-footer">
            <Button
              className="button"
              variant="contained"
              onClick={handleUpdatePermission}
            >
              Save Changes
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={automationWarning} className="checklistModal">
          <Box className="smallModel__head" style={{ padding: "12px 16px" }}>
            <Typography variant="h3" className="smallModel__title">
              Warning
            </Typography>
            <Button
              className="smallModel__closeBtn"
              onClick={() => {
                setAutomationWarning(false);
                setFormAction("");
              }}
            >
              <Close />
            </Button>
          </Box>
          <DialogContent>
            <div className="warning">
              <div className="warning-header">
                <h3>Automation Impact Detected</h3>
                <ErrorOutline color="warning" />
              </div>
              <p className="warning-text">
                This form is used in an active automation rule. If you proceed
                this action, the rule will be put "On Hold" temporarily and will
                need manual review.
              </p>
              {formRelatedRules.length > 0 && (
                <div>
                  <h4>Affected rules</h4>
                  {formRelatedRules.map((rule, index) => (
                    <p>
                      {index + 1}. {rule}
                    </p>
                  ))}
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions className="checklist-footer">
            <Button
              className="button"
              variant="contained"
              onClick={() => {
                setAutomationWarning(false);
                if (currentForm) {
                  if (formAction === "Update") {
                    handleSwitchChange(currentForm, true);
                  } else {
                    setDeletePopup(true);
                  }
                }
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default BusinessForm;
